
const $ = jQuery.noConflict();

'use strict';
const mediaVids = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.moveEvents();
		this.overlayChange();
	},

	/** @description Bind Events */
	moveEvents: function() {
		/* $('.media__box-overlay').on('click', function() {
			if(!$(this).hasClass('remove-overlay')) {
				$('.media__box-overlay').removeClass('remove-overlay');
				$(this).addClass('remove-overlay');
			}else {
				$(this).removeClass('remove-overlay');
			}
		}); */
	},

	overlayChange: function() {
		$('.media__box').on('mouseenter', function() {
			if($(window).width() > 1199) {
				if($(this).find('video').get(0).paused && !$(this).find('.media__box-overlay').hasClass('overlay-active')) {
					$(this).find('.media__box-overlay').addClass('overlay-active');
				}
			}
		});

		$('.media__box').on('mouseleave', function() {
			if($(window).width() > 1199) {
				if($(this).find('video').get(0).paused) {
					if(!$(this).find('.media__box-overlay').hasClass('overlay-active')) {
						$(this).find('.media__box-overlay').addClass('overlay-active');
					}else {
						$(this).find('.media__box-overlay').removeClass('overlay-active');
					}
				}
			}
		});

		if($(window).width() <= 1199) {
			$('.media__box').on('touchstart', function() {
				$('.media__box-overlay').removeClass('overlay-active');
				$(this).find('.media__box-overlay').addClass('overlay-active');
				/* if($(this).find('video').get(0).paused) {
					$(this).find('.media__box-overlay').addClass('overlay-active');
				}else {
					$(this).find('.media__box-overlay').removeClass('overlay-active');
				} */
			});
		}
	},
};

export default mediaVids;
